import React from 'react';
import {
  DexDbUpdatesStore,
  DexSearchStore,
  DexExecutionStore,
  DexOperationsStore,
} from '@zen-dex/utils';
import {
  StorageUpdaterStore,
  ErrorReportingStore,
  ConfigStore,
  BlockchainInfoStore,
  NamingJsonStore,
  RedeemAssetStore,
} from '@zen/common-app-parts';
import DestroyStore from '../../stores/DestroyStore';
import WalletProvider from './components/WalletProvider';
import SettingsStoreProvider from './components/SettingsStoreProvider';
import SendProvider from './components/SendProvider';
import { DbClientProvider } from './components/DbClientContext';
import ChangesProvider from './components/ChangesProvider';
import ExecuteContractProvider from './components/ExecuteContractProvider';
import NamingAssetStoreProvider from './components/NamingAssetStoreProvider';

export default function StoreProviders({ dbClient, storage, config, children }) {
  return (
    <NamingJsonStore.Provider url={config.contractNamingUrl}>
      <ConfigStore.Provider config={config}>
        <StorageUpdaterStore.Provider storage={storage}>
          <ErrorReportingStore.Provider config={config}>
            <DbClientProvider dbClient={dbClient}>
              <SettingsStoreProvider storage={storage} config={config}>
                <NamingAssetStoreProvider config={config}>
                  <BlockchainInfoStore.Provider>
                    <DexDbUpdatesStore.Provider
                      dbClient={dbClient}
                      storage={storage}
                      config={config}
                    >
                      <DexSearchStore.Provider dbClient={dbClient}>
                        <WalletProvider storage={storage}>
                          <ExecuteContractProvider>
                            <DexOperationsStore.Provider dbClient={dbClient}>
                              <DexExecutionStore.Provider dbClient={dbClient}>
                                <ChangesProvider>
                                  <SendProvider>
                                    <DestroyStore.Provider>
                                      <RedeemAssetStore.Provider
                                        nodeUrl={config.nodeUrl}
                                        oracleData={{
                                          oracleUrl: config.oracleUrl,
                                          oraclePk: config.oraclePk,
                                          oracleCid: config.oracleCid,
                                        }}
                                      >
                                        {children}
                                      </RedeemAssetStore.Provider>
                                    </DestroyStore.Provider>
                                  </SendProvider>
                                </ChangesProvider>
                              </DexExecutionStore.Provider>
                            </DexOperationsStore.Provider>
                          </ExecuteContractProvider>
                        </WalletProvider>
                      </DexSearchStore.Provider>
                    </DexDbUpdatesStore.Provider>
                  </BlockchainInfoStore.Provider>
                </NamingAssetStoreProvider>
              </SettingsStoreProvider>
            </DbClientProvider>
          </ErrorReportingStore.Provider>
        </StorageUpdaterStore.Provider>
      </ConfigStore.Provider>
    </NamingJsonStore.Provider>
  );
}
